import Control from '../Control';
import classnames from 'classnames';

import Fragment from '../inspector/Fragment';
import Inspector from '../inspector/Inspector';
const { ToggleControl, Dashicon } = wp.components;

export default class Responsive extends Control {
  /**
   * Add custom attribute for mobile visibility
   *
   * @param {Object} settings Settings for the block
   *
   * @return {Object} Modified settings
   */
  registerBlockType(settings) {
    //check if object exists for old Gutenberg version compatibility
    if (typeof settings.attributes !== 'undefined') {
      settings.attributes = Object.assign(settings.attributes, {
        ResponsiveControl_visibleOnMobile: {
          type: 'boolean',
          default: true,
        },
        ResponsiveControl_visibleOnTablet: {
          type: 'boolean',
          default: true,
        },
        ResponsiveControl_visibleOnLaptop: {
          type: 'boolean',
          default: true,
        },
        ResponsiveControl_visibleOnDesktop: {
          type: 'boolean',
          default: true,
        },
      });
    }

    return settings;
  }

  /**
   * Add mobile visibility controls as Block Panel
   *
   * @param {function} Block Block edit component
   *
   * @return {function} Modified block edit component
   */
  BlockEdit(Block, props) {
    const {
			attributes,
			setAttributes,
    } = props;

    const {
      ResponsiveControl_visibleOnMobile,
      ResponsiveControl_visibleOnTablet,
      ResponsiveControl_visibleOnLaptop,
      ResponsiveControl_visibleOnDesktop,
		} = attributes;

    return (
      <Fragment>
        <Block {...props} />
        <Inspector>
          <Inspector.Body
            title={this.options.label || 'Responsive'}
            initialOpen={false}
          >
            <Inspector.Row>
              <Dashicon icon="smartphone"/>
              <ToggleControl
                  label="Mobile"
                  checked={ !! ResponsiveControl_visibleOnMobile }
                  onChange={ () => setAttributes( {  ResponsiveControl_visibleOnMobile: ! ResponsiveControl_visibleOnMobile } ) }
                  help={ ResponsiveControl_visibleOnMobile ? 'Showing on mobile devices':'Hidden on mobile devices'}
                />
            </Inspector.Row>
            <Inspector.Row>
              <Dashicon icon="tablet"/>
              <ToggleControl
                  label="Mobile"
                  checked={ !! ResponsiveControl_visibleOnTablet }
                  onChange={ () => setAttributes( {  ResponsiveControl_visibleOnTablet: ! ResponsiveControl_visibleOnTablet } ) }
                  help={ ResponsiveControl_visibleOnTablet ? 'Showing on tablet devices':'Hidden on tablet devices'}
                />
            </Inspector.Row>
            <Inspector.Row>
              <Dashicon icon="laptop"/>
              <ToggleControl
                  label="Mobile"
                  checked={ !! ResponsiveControl_visibleOnLaptop }
                  onChange={ () => setAttributes( {  ResponsiveControl_visibleOnLaptop: ! ResponsiveControl_visibleOnLaptop } ) }
                  help={ ResponsiveControl_visibleOnLaptop ? 'Showing on laptop devices':'Hidden on laptop devices'}
                />
            </Inspector.Row>
            <Inspector.Row>
              <Dashicon icon="desktop"/>
              <ToggleControl
                  label="Mobile"
                  checked={ !! ResponsiveControl_visibleOnDesktop }
                  onChange={ () => setAttributes( {  ResponsiveControl_visibleOnDesktop: ! ResponsiveControl_visibleOnDesktop } ) }
                  help={ ResponsiveControl_visibleOnDesktop ? 'Showing on desktop devices':'Hidden on desktop devices'}
                />
            </Inspector.Row>
          </Inspector.Body>
        </Inspector>
      </Fragment>
    );
  }

  /**
   * Add custom element class on save element
   *
   * @param {Object} props Block element
   * @param {Object} blockType Blocks object
   * @param {Object} attributes Blocks attributes
   *
   * @return {Object} Modified block element.
   */
  extraProps(props, blockType, attributes) {
    const {
      ResponsiveControl_visibleOnMobile,
      ResponsiveControl_visibleOnTablet,
      ResponsiveControl_visibleOnLaptop,
      ResponsiveControl_visibleOnDesktop,
		} = attributes;

    //check if attribute exists for old Gutenberg version compatibility
    if (typeof ResponsiveControl_visibleOnMobile !== 'undefined' && !ResponsiveControl_visibleOnMobile) {
      props.className = classnames(props.className, 'hidden--sm');
    }
    if (typeof ResponsiveControl_visibleOnTablet !== 'undefined' && !ResponsiveControl_visibleOnTablet) {
      props.className = classnames(props.className, 'hidden--md');
    }
    if (typeof ResponsiveControl_visibleOnLaptop !== 'undefined' && !ResponsiveControl_visibleOnLaptop) {
      props.className = classnames(props.className, 'hidden--lg');
    }
    if (typeof ResponsiveControl_visibleOnDesktop !== 'undefined' && !ResponsiveControl_visibleOnDesktop) {
      props.className = classnames(props.className, 'hidden--xl');
    }

    return props;
  }
}
